import React, { useEffect, useRef } from 'react'
import { useConfigurationStore, useCountdownFSBonusStore } from '@stores'
import { formatMoney } from '@utils/money'
import { AnimatedSprite, useShrinkTextToFit } from '@amusnet/react-ui'
import spritesheetSrc from '@assets/bonus-system/countdown-gift-animation.png'
import animatedSpriteConfig from '@assets/bonus-system/countdown-gift-animation.json'
import { useTranslation } from '@amusnet/translations/react'

const CFSEndBonus: React.FC = () => {
    const totalWin = useCountdownFSBonusStore((state) => state.totalWin)
    const setTotalWin = useCountdownFSBonusStore((state) => state.setTotalWin)
    const hasActiveBonusesLeft = useCountdownFSBonusStore((state) => state.hasActiveBonusesLeft)

    const { t } = useTranslation()
    const currency = useConfigurationStore((state) => state.currency)
    const currencyHideCents = useConfigurationStore((state) => state.currencyHideCents)

    const formattedTotalWin = formatMoney(Number(totalWin), currencyHideCents)
    const totalWinAmountRef = useRef<HTMLParagraphElement>(null)
    const hasWon = +totalWin > 0

    const text = hasActiveBonusesLeft
        ? t('gameui.bonusSystem.stillHaveActiveBonuses')
        : t('gameui.bonusSystem.playingWithRealMoney')

    useEffect(() => {
        return () => setTotalWin('0')
    }, [])

    useShrinkTextToFit({
        refresh: [formattedTotalWin],
        designFontSize: 128,
        bounds: { width: 590 },
        textRef: totalWinAmountRef,
    })

    return (
        <div className="flex flex-col items-center justify-between">
            <div className="flex flex-col w-full bg-[#19191C]">
                <AnimatedSprite
                    spritesheetSrc={spritesheetSrc}
                    config={animatedSpriteConfig}
                    duration={1.5}
                    className="m-auto"
                />

                <div
                    id="countdown-end-bonus-text"
                    className="flex flex-col items-center text-center mt-[-3px] w-full h-[273px] bg-[linear-gradient(180deg,#19191C_19.44%,#793F06_100%)]"
                >
                    <p className="text-4xl font-bold text-white">
                        {hasWon ? t('gameui.bonusSystem.hasEnded') : t('gameui.bonusSystem.youDidNotScoreAWin')}
                    </p>
                    <p
                        className={`text-4xl font-black text-yellow-400 leading-tight px-1 ${hasWon ? '' : 'mt-[10px] mb-[40px]'}`}
                    >
                        {hasWon ? t('gameui.bonusSystem.youHaveWon') : t('gameui.bonusSystem.betterLuckNextTime')}
                    </p>

                    {hasWon && (
                        <div className="flex flex-col items-center leading-tight">
                            <p className="text-9xl font-black text-yellow-400" ref={totalWinAmountRef}>
                                {formattedTotalWin}
                                <span className="text-5xl font-black text-yellow-400 pl-2">{currency}</span>
                            </p>
                        </div>
                    )}

                    <p className="text-4xl font-bold text-white">{text}</p>
                </div>
            </div>
        </div>
    )
}

export default CFSEndBonus
